/**
 * @file reportWebVitals.js
 * @description Utility for forwarding Core Web Vitals measurements to a
 *   supplied callback. Metrics include CLS, FID, FCP, LCP, and TTFB.
 * @see https://web.dev/vitals/
 * @author IEEE CIS UJ Web Team
 */

/**
 * Lazily imports the `web-vitals` package and emits measurements through the
 * provided callback when available.
 *
 * @param {Function} onPerfEntry - Consumer callback for metrics payloads.
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
